import { GradingMethod } from '../api';

export interface ExamTrackingState {
  id: string
  attempts: ExamAttempt[]
  effectiveGrading: GradingMethod
}

export interface ExamAttempt {
  timestamp: Date;
  score: {
    min: number
    max: number
    raw: number
  }
  passingScore: number
  result: 'passed' | 'failed'
  durationSeconds: number
}

export function defaultExamTrackingState(id: string): ExamTrackingState {
  return {
    id,
    attempts: [],
    effectiveGrading: 'highest-grade'
  }
}
